module.exports = __webpack_public_path__ + "National2Web-Regular.woff?5bc3f7032d18c7d5b08685afabf77d2f";